<template>
    <div class="main-container">
        <!-- Navbar section -->
		<HeaderSingle />

        <div class="section-space-header bg-grey" id="pricing">
            <div class="pricing-table-title-area position-relative ">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-12  wow move-up">
                            <div class="section-title-wrapper text-center section-space--mb_60">
                                <h2 class="section-title font-weight--light mb-15">Terms and Conditions</h2>
                                <!-- <span class="section-text wow move-up">These terms of service (TOS) govern your use of this site, which is provided by our company. By accessing this site, you are indicating your acknowledgement and acceptance of these terms of use and privacy policy. These terms of use are subject to change by our company at any time in its discretion</span>
                                <span class="section-text wow move-up">Your use of this site after such changes are implemented constitutes your acknowledgement and acceptance of the changes. Please consult these terms of use regularly.</span> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <tncContent />
 
        <!-- footer section -->
        <FooterMain />
    </div>
</template>

<script>
    import 'bootstrap/dist/css/bootstrap.css'
    import 'swiper/dist/css/swiper.css'
    import '@/assets/static-style/style.scss';
    import 'slick-carousel/slick/slick.css'

    import HeaderSingle from './components/sections/HeaderSingle.vue'
    import tncContent from './components/sections/TnCContent.vue'
    import FooterMain from './components/FooterMain.vue'

    export default {
        name: 'app',
        components: {
            HeaderSingle,
            tncContent,
            FooterMain
        }
    }
</script>




<style lang="scss">
    @import '@/assets/static-style/_variabls.scss';
    @import '@/assets/scss/page-section/_payment.scss';
</style>

<style>
    .section-space-header {
        padding-top: 175px;
    }
    @media only screen and (max-width: 1199px) {
        .section-space-header {
            padding-top: 120px;
        }
    }
    @media only screen and (max-width: 767px) {
        .section-space-header {
            padding-top: 100px;
        }
    }
</style>